import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function TermsOfService() {
  useDocumentMeta({
    title: 'Terms of Service | VCA Capital Advisors',
    description: 'VCA Capital Advisors terms of service. Conditions and requirements for using our business funding brokerage and advisory services.',
    path: '/terms'
  });
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-white/20" data-id="element-696">
      <Navigation data-id="element-697" />

      <main className="pt-32 pb-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-698">
        <div className="mb-12" data-id="element-699">
          <h1 className="text-4xl md:text-5xl font-medium mb-4 tracking-tight" data-id="element-700">
            Terms of Service
          </h1>
          <p className="text-zinc-400" data-id="element-701">
            Last Updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
          </p>
        </div>

        <div className="space-y-10 text-zinc-300 leading-relaxed" data-id="element-702">
          <section data-id="element-703">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-704">
              1. Acceptance of Terms
            </h2>
            <p data-id="element-705">
              By accessing or using the website and services provided by VCA
              Capital Advisors Inc. ("we," "our," or "us"), you agree to be
              bound by these Terms of Service. If you do not agree to these
              terms, please do not use our services.
            </p>
          </section>

          <section data-id="element-706">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-707">
              2. Description of Services
            </h2>
            <p data-id="element-708">
              VCA Capital Advisors Inc. acts as a business funding brokerage and
              advisory service. We assist businesses in identifying, applying
              for, and securing commercial financing from third-party lenders
              and funding partners. We are not a direct lender, bank, or
              depository institution. Any funding offers, terms, and approvals
              are determined solely by the third-party funding providers.
            </p>
          </section>

          <section className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800" data-id="element-709">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-710">
              3. SMS/Text Messaging Terms
            </h2>
            <p className="mb-3" data-id="element-711">
              <strong data-id="element-712">Program Name:</strong> VCA Capital Advisors Account
              Notifications.
            </p>
            <p className="mb-3" data-id="element-713">
              <strong data-id="element-714">Program Description:</strong> Messages are sent by VCA
              Capital Advisors Inc. to customers and registered portal users who
              create an account at vcacapitaladvisors.com/portal. Messages are
              strictly transactional: two-factor authentication and one-time
              passcodes, sign-in alerts, password resets, account and document
              status notifications, document request notifications, and account
              security or account-change alerts. No marketing or promotional SMS
              is sent through this program.
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-715">
              <li data-id="element-716">
                <strong data-id="element-717">Consent:</strong> By creating an account and providing
                your mobile phone number, you expressly consent to receive
                transactional SMS messages from VCA Capital Advisors Inc. as
                described above.
              </li>
              <li data-id="element-718">
                <strong data-id="element-719">Frequency:</strong> Message frequency varies based on
                your account activity.
              </li>
              <li data-id="element-720">
                <strong data-id="element-721">Rates:</strong> Standard message and data rates may
                apply depending on your mobile carrier plan.
              </li>
              <li data-id="element-722">
                <strong data-id="element-723">Opt-Out:</strong> You may opt out at any time by texting{' '}
                <strong data-id="element-724">STOP</strong>. After texting STOP, you will receive one
                final confirmation message and no further texts.
              </li>
              <li data-id="element-725">
                <strong data-id="element-726">Assistance:</strong> Text <strong data-id="element-727">HELP</strong> for
                help, or contact us at info@vcacapitaladvisors.com or (646)
                331-2752.
              </li>
              <li data-id="element-728">
                <strong data-id="element-729">Carrier Liability:</strong> Mobile carriers are not
                liable for delayed or undelivered messages.
              </li>
              <li data-id="element-730">
                <strong data-id="element-731">Supported Carriers:</strong> AT&amp;T, T-Mobile,
                Verizon, Sprint, Boost Mobile, Cricket Wireless, MetroPCS, U.S.
                Cellular, Virgin Mobile, and others.
              </li>
              <li data-id="element-732">
                <strong data-id="element-733">Not a Condition:</strong> SMS consent is not required to
                use our services. You may communicate with us solely via email
                or phone calls.
              </li>
            </ul>
          </section>

          <section data-id="element-734">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-735">
              4. User Responsibilities
            </h2>
            <p className="mb-3" data-id="element-736">When using our services, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-737">
              <li data-id="element-738">
                Provide accurate, current, and complete information about your
                business and financial status.
              </li>
              <li data-id="element-739">Maintain the confidentiality of any account credentials.</li>
              <li data-id="element-740">Use our services only for lawful business purposes.</li>
              <li data-id="element-741">
                Not submit fraudulent applications or misrepresent your identity
                or business details.
              </li>
            </ul>
          </section>

          <section data-id="element-742">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-743">
              5. Disclaimer of Warranties
            </h2>
            <p data-id="element-744">
              Our services are provided on an "as is" and "as available" basis.
              VCA Capital Advisors Inc. makes no warranties, expressed or
              implied, regarding the availability of funding, specific rates,
              terms, or the approval of any application. We do not guarantee
              that you will receive funding or that the terms offered by
              third-party lenders will meet your expectations.
            </p>
          </section>

          <section data-id="element-745">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-746">
              6. Limitation of Liability
            </h2>
            <p data-id="element-747">
              To the maximum extent permitted by law, VCA Capital Advisors Inc.
              and its affiliates, officers, employees, and agents shall not be
              liable for any indirect, incidental, special, consequential, or
              punitive damages, or any loss of profits or revenues, whether
              incurred directly or indirectly, or any loss of data, use,
              goodwill, or other intangible losses resulting from your use of
              our services or any interactions with third-party lenders.
            </p>
          </section>

          <section data-id="element-748">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-749">
              7. Indemnification
            </h2>
            <p data-id="element-750">
              You agree to indemnify and hold harmless VCA Capital Advisors
              Inc., its affiliates, and their respective officers, directors,
              employees, and agents from any claims, damages, liabilities,
              costs, or expenses (including reasonable attorneys' fees) arising
              out of your use of our services, your violation of these Terms, or
              your violation of any rights of a third party.
            </p>
          </section>

          <section data-id="element-751">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-752">
              8. Governing Law
            </h2>
            <p data-id="element-753">
              These Terms of Service and your use of our website shall be
              governed by and construed in accordance with the laws of the State
              of New York, without regard to its conflict of law principles. Any
              legal action or proceeding arising under these Terms shall be
              brought exclusively in the federal or state courts located in New
              York, New York.
            </p>
          </section>

          <section data-id="element-754">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-755">
              9. Changes to Terms
            </h2>
            <p data-id="element-756">
              We reserve the right to modify or replace these Terms of Service
              at any time. Any changes will be effective immediately upon
              posting on this page. Your continued use of our services after any
              such changes constitutes your acceptance of the new Terms.
            </p>
          </section>

          <section data-id="element-757">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-758">
              10. Contact Information
            </h2>
            <p className="mb-4" data-id="element-759">
              If you have any questions about these Terms of Service, please
              contact us at:
            </p>
            <div className="bg-zinc-900/30 p-6 rounded-xl border border-zinc-800" data-id="element-760">
              <p className="font-medium text-white mb-1" data-id="element-761">
                VCA Capital Advisors Inc.
              </p>
              <p data-id="element-762">2248 Broadway STE 1784</p>
              <p data-id="element-763">New York, NY 10024</p>
              <p className="mt-2" data-id="element-764">
                Email:{' '}
                <a href="mailto:info@vcacapitaladvisors.com" className="text-white hover:underline" data-id="element-765">
                  info@vcacapitaladvisors.com
                </a>
              </p>
              <p data-id="element-766">
                Phone:{' '}
                <a href="tel:646-331-2752" className="text-white hover:underline" data-id="element-767">
                  (646) 331-2752
                </a>
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-768" />
    </div>;
}